import React, { Component } from 'react';
import { connect } from 'react-redux';
import DocumentTitle from 'react-document-title';
import { Col, Container, Row, Table } from 'reactstrap';
import { fetchCountries } from 'actions';
import { Crumbs } from 'containers';

class Countries extends Component {
	state = {
		idFilter: '',
		nameFilter: '',
		regionFilter: ''
	};

	componentDidMount() {
		this.props.fetchCountries();
	}

	onReloadList = () => {
		this.props.fetchCountries();
	};

	handleChange = (event) => {
		this.setState({
			[event.target.id]: event.target.value
		});
	};

	buildResultsTable() {
		console.log(this);
		let { countries = [] } = this.props;

		return (
			<Row noGutters>
				<Col xs="12">
					<Table>
						<thead>
							<tr>
								<th style={{ width: '60px' }}>#</th>
								<th>ID</th>
								<th>Name</th>
								<th>Region</th>
							</tr>
						</thead>
						<tbody>
							{countries.map((country, ind) => {
								const { id, name, region } = country;
								const dspInd = ind + 1;
								return (
									<tr key={`region${dspInd}`}>
										<th scope="row" style={{ width: '60px' }}>
											{dspInd}
										</th>
										<td style={{ width: '60px' }}>{id}</td>
										<td style={{ width: '80px' }}>{name}</td>
										<td style={{ width: '200px' }}>{region}</td>
										<td style={{ width: '45px' }}></td>
									</tr>
								);
							})}
						</tbody>
					</Table>
				</Col>
			</Row>
		);
	}

	render() {
		return (
			<DocumentTitle title="Gains Admin | Countries">
				<Container fluid>
					<Crumbs path={[{ title: 'Countries' }]} />
					{this.buildResultsTable()}
				</Container>
			</DocumentTitle>
		);
	}
}

const mapStateToProps = ({ countries }) => {
	return {
		countries
	};
};

const mapDispatchToProps = (dispatch) => ({
	fetchCountries: () => dispatch(fetchCountries())
});

export default connect(mapStateToProps, mapDispatchToProps)(Countries);
